import {
  defaultLifeCycle, destroyStates, readStates, saveStates,
} from '@/constants/lifecycle';

const collectionActions = {
  CHECK_COLLECTION_IMAGE: 'CHECK_COLLECTION_IMAGE',
  CLOSE_COLLECTION: 'CLOSE_COLLECTION',
  CLOSE_COLLECTIONS: 'CLOSE_COLLECTIONS',
  CREATE_COLLECTION: 'CREATE_COLLECTION',
  DELETE_COLLECTION: 'DELETE_COLLECTION',
  DESTROY_COLLECTION: 'DESTROY_COLLECTION',
  DESTROY_COLLECTION_ERROR: 'DESTROY_COLLECTION_ERROR',
  EDIT_COLLECTION: 'EDIT_COLLECTION',
  FETCH_COLLECTION: 'FETCH_COLLECTION',
  FETCH_COLLECTIONS: 'FETCH_COLLECTIONS',
  HIDE_DELETE_COLLECTION: 'HIDE_DELETE_COLLECTION',
  HIDE_SAVE_COLLECTION: 'HIDE_SAVE_COLLECTION',
  NEW_COLLECTION: 'NEW_COLLECTION',
  NEW_COLLECTION_ERROR: 'NEW_COLLECTION_ERROR',
  REFRESH_COLLECTIONS: 'REFRESH_COLLECTIONS',
  RESET_COLLECTION_IMAGE: 'RESET_COLLECTION_IMAGE',
  SAVE_COLLECTION_IMAGE: 'SAVE_COLLECTION_IMAGE',
  SAVE_COLLECTION_IMAGE_ERROR: 'SAVE_COLLECTION_IMAGE_ERROR',
  SAVE_COLLECTION_IMAGE_SUCCESS: 'SAVE_COLLECTION_IMAGE_SUCCESS',
  SHOW_COLLECTION: 'SHOW_COLLECTION',
  SHOW_COLLECTION_ERROR: 'SHOW_COLLECTION_ERROR',
  SHOW_COLLECTIONS_ERROR: 'SHOW_COLLECTIONS_ERROR',
  SHOW_COLLECTIONS_RESULTS: 'SHOW_COLLECTIONS_RESULTS',
  SHOW_DELETE_COLLECTION: 'SHOW_DELETE_COLLECTION',
  SHOW_DELETE_COLLECTIONS: 'SHOW_DELETE_COLLECTIONS',
  SHOW_SAVE_COLLECTION: 'SHOW_SAVE_COLLECTION',
  TOGGLE_COLLECTION_SELECTED: 'TOGGLE_COLLECTION_SELECTED',
  TOGGLE_COLLECTIONS_COLUMN_ORDER_BY: 'TOGGLE_COLLECTIONS_COLUMN_ORDER_BY',
  TOGGLE_COLLECTIONS_PRESENTATION: 'TOGGLE_COLLECTIONS_PRESENTATION',
  TOGGLE_COLLECTIONS_SELECTED: 'TOGGLE_COLLECTIONS_SELECTED',
  TOGGLE_COLLECTIONS_SINGLE_SORTING: 'TOGGLE_COLLECTIONS_SINGLE_SORTING',
  UPDATE_ACTIVE_COLLECTION_PROPERTIES: 'UPDATE_ACTIVE_COLLECTION_PROPERTIES',
  UPDATE_COLLECTION: 'UPDATE_COLLECTION',
  UPDATE_COLLECTION_CANCEL: 'UPDATE_COLLECTION_CANCEL',
  UPDATE_COLLECTION_ERROR: 'UPDATE_COLLECTION_ERROR',
  UPDATE_COLLECTION_PROPERTIES: 'UPDATE_COLLECTION_PROPERTIES',
  UPDATE_COLLECTION_SUCCESS: 'UPDATE_COLLECTION_SUCCESS',
  UPDATE_COLLECTIONS_FILTER: 'UPDATE_COLLECTIONS_FILTER',
};

export const collectionLists = ['all', 'ribbon'];

export const collectionCategories = [...collectionLists, 'open'];

export const collectionLifeCycle = [...defaultLifeCycle];

export const collectionStates = {
  ...readStates,
  ...saveStates,
  ...destroyStates,
};

export const logoValidationParams = {
  max_file_size: 512000,
  file_extensions: ['.jpg', '.jpeg', '.png'],
};

export default collectionActions;
